<template>
  <div class="LandingHomeComponent">
    <greeting/>
  </div>
</template>

<script>
  import Greeting from '../components/Greeting'

  export default {
    name: 'LandingHome',
    components: { Greeting },
    props: {
      // https://vuejs.org/v2/guide/components.html#Prop-Validation
      // propname: String
    },
    computed: {},
    watch: {},
    mixins: [],
    data: function () {
      return {}
    },
    methods: {},
    created () {
    },
    mounted () {
    }
  }
</script>

<style scoped>
  .LandingHomeComponent {
  }
</style>
